/* Start an animated SVG only when it scrolls into view.
   Put the asset URL in data-inview-src (leave src empty); this sets src — and
   thus starts the SVG's internal animation from the beginning — on first view. */
(function () {
  function load(img) {
    var s = img.getAttribute('data-inview-src');
    if (s && !img.getAttribute('src')) {
      // Unique URL forces a fresh (uncached) fetch so the SVG's one-shot draw
      // replays every time — a cached copy would paint the finished frame instead.
      img.src = s + (s.indexOf('?') < 0 ? '?' : '&') + 'draw=' + Date.now();
    }
  }
  function arm(root) {
    var imgs = (root || document).querySelectorAll('img[data-inview-src]:not([src])');
    if (!imgs.length) return;
    if (!('IntersectionObserver' in window)) {
      Array.prototype.forEach.call(imgs, load);
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { load(e.target); io.unobserve(e.target); }
      });
    }, { threshold: 0.25 });
    Array.prototype.forEach.call(imgs, function (img) { io.observe(img); });
  }
  function run() { arm(document); }
  if (document.readyState !== 'loading') { run(); }
  else { document.addEventListener('DOMContentLoaded', run); }
  document.addEventListener('shopify:section:load', function (e) { arm(e.target || document); });
})();
